<template>
  <el-dialog
      :title="$lang('下载中心')"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose">
    <div class="main-download-center">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" @click="onSubmit" icon="el-icon-search" >{{$lang('查询')}}</el-button>
        </el-form-item>
      </el-form>
      <el-table
          :data="tableData"
          border
          height="420"
          style="width: 100%">
        <el-table-column
            prop="createTime"
            :label="$lang('日期')"
            width="160"
        >
        </el-table-column>
        <el-table-column
            prop="module"
            :label="$lang('模块')"
            width="120"
        >
        </el-table-column>
        <el-table-column
            prop="fileName"
            :label="$lang('文件名')"
            width="280"
        >
        </el-table-column>
        <el-table-column
            prop="fileStatusStr"
            :label="$lang('状态')"
        >
        </el-table-column>
        <el-table-column
            fixed="right"
            :label="$lang('操作')"
            width="100">
          <template slot-scope="scope" v-if="scope.row.fileUrl" >
            <el-button type="text" size="small" :loading="loading" @click="download(scope.row)">{{$lang('下载')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import { getDownloadRecord, getDownloadFileUrl } from '@api/module/customer'
import { RESPONSE_SUCCESS } from '@constants'

export default {
  name: 'DownloadCenter',
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      loading: false,
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val
        if (val) {
          this.onSubmit()
        }
      },
    },
  },
  methods: {
    async download(row) {
      const param = {}
      param.fileUrl = row.fileUrl
      this.loading = true
      const { code, data, msg } = await getDownloadFileUrl(param)
      this.loading = false
      if (code === RESPONSE_SUCCESS) {
        const elink = document.createElement('a')
        elink.style.display = 'none'
        elink.href = data
        elink.setAttribute('download', row.fileName)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink)
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    async onSubmit() {
      this.loading = true
      const { code, data, msg } = await getDownloadRecord()
      this.loading = false
      if (code === RESPONSE_SUCCESS) {
        if (data && data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            const status = data[i].fileStatus + ''
            const genderDict = { '-1': this.$lang('任务已创建'), '0': this.$lang('未处理'), '1': this.$lang('正在处理'), '2': this.$lang('处理成功'), '3': this.$lang('处理失败'), '4': this.$lang('处理失败') }
            data[i].fileStatusStr = genderDict[status] || status
          }
          this.tableData = data
        }
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    handleClose() {
      this.$emit('handleClose')
    },

  },
}
</script>

<style scoped>
.main-download-center{
  font-weight: 500;
  color: #666;
  height: 500px;
}
</style>
